<template>
  <div
    id="create-bundle"
  >
    <h2>Create Bundle</h2>

    <bundle-form />
  </div>
</template>

<script>
import BundleForm from '@/components/BundleForm'

import BundleStore from '@/stores/BundleStore'

export default {
  data () {
    return BundleStore.state
  },

  components: {
    'bundle-form': BundleForm
  }
}

</script>



// WEBPACK FOOTER //
// src/components/BundleCreate.vue